import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { Button, MapSidebar } from "@landtechnologies/components";
import { ReportSidebarContent } from "./ReportSidebarContent";
import { Stores, useGlobalState, useTranslation } from "react-migration/lib";
import { SiteReportUtilitySteps } from "react-migration/domains/sites/typings/SiteUtilityReport";
import { setActiveSiteReportUtilityStep } from "src/js/stores/site/actions/setActiveSiteReportUtilityStep";
import classNames from "classnames";
import { useUtilitiesBuffer } from "react-migration/layouts/map/Multilayer/Bundle/useUtilitiesBuffer";

type ReportSidebarProps = {
  onClose: () => void;
};

export const ReportSidebar: React.FC<ReportSidebarProps> = ({ onClose }) => {
  const { t } = useTranslation();
  const [{ activeSiteReportUtilityStep }] = useGlobalState(Stores.site);
  const [isDrawingToolbarOpen, setIsDrawingToolbarOpen] = useState<boolean>(
    JSON.parse(localStorage.getItem("drawingToolbarOpen")!)
  );
  const isErrorPage = activeSiteReportUtilityStep === SiteReportUtilitySteps.Error;

  useUtilitiesBuffer();

  useEffect(() => {
    function handleDrawingToolbar() {
      setIsDrawingToolbarOpen(JSON.parse(localStorage.getItem("drawingToolbarOpen")!));
    }
    window.addEventListener("storage", handleDrawingToolbar);
    return () => window.removeEventListener("storage", handleDrawingToolbar);
  }, []);

  return createPortal(
    <MapSidebar
      className={classNames(
        isDrawingToolbarOpen ? "atlas-h-[calc(100vh-90px)]" : "atlas-h-[calc(100vh-50px)]",
        isDrawingToolbarOpen ? "atlas-top-10" : "atlas-top-0",
        "atlas-absolute atlas-left-0 atlas-z-30 sm:atlas-max-w-xl sm:!atlas-w-screen"
      )}
    >
      <MapSidebar.Header className="atlas-p-3 atlas-bg-inherit">
        <MapSidebar.HeaderTitle>
          <div
            className={classNames(
              "atlas-flex atlas-w-full",
              isErrorPage ? "atlas-justify-between atlas-items-center" : "atlas-justify-end"
            )}
          >
            {isErrorPage && (
              <Button.Borderless
                size="small"
                onClick={() => setActiveSiteReportUtilityStep(SiteReportUtilitySteps.Overview)}
                className="atlas-text-white atlas-text-sm atlas-gap-1 atlas-pl-0"
              >
                <i className="icon-lt-arrow-left-s-line" />
                {t("sites.utility_report.back")}
              </Button.Borderless>
            )}
            <MapSidebar.Close onClose={onClose} />
          </div>
        </MapSidebar.HeaderTitle>
      </MapSidebar.Header>
      <MapSidebar.Body className="atlas-flex">
        <div className="atlas-h-100 atlas-bg-white atlas-rounded-md atlas-h-full atlas-flex atlas-flex-col">
          <ReportSidebarContent />
        </div>
      </MapSidebar.Body>
    </MapSidebar>,
    document.getElementById("utilities-report-sidebar-portal") ?? document.body
  );
};
